var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightSwitchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 61,
    viewBox: "0 0 42 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 61,
    rx: 2,
    fill: "#668BA6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 50L13 51V31L20 13L10 9V50Z",
    fill: "#CCD8E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13H42L32 9H10L20 13Z",
    fill: "#BACAD6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    transform: "matrix(1 0 0 -1 13 51)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 31H35L42 13H20L13 31Z",
    fill: "#F5F7F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6394 24.3335C24.4694 24.3335 25.6834 23.5126 26.3985 21.8065L27.0015 20.3677C27.7166 18.6615 27.1907 17.8407 25.3607 17.8407C23.5307 17.8407 22.3166 18.6615 21.6015 20.3677L20.9985 21.8065C20.2834 23.5126 20.8094 24.3335 22.6394 24.3335ZM23.053 23.3466C22.013 23.3466 21.7701 22.8763 22.2224 21.7972L22.8177 20.3769C23.2699 19.2979 23.9071 18.8275 24.9471 18.8275C25.9871 18.8275 26.2299 19.2979 25.7777 20.3769L25.1824 21.7972C24.7301 22.8763 24.093 23.3466 23.053 23.3466Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9482 24.2228H28.1482L29.795 20.2939H31.015L31.3744 19.4362H30.1544L30.3207 19.0396C30.5255 18.5508 30.7728 18.3664 31.2428 18.3664H31.8728L32.2401 17.4902H31.2501C30.2601 17.4902 29.5613 17.9883 29.1284 19.0212L28.9544 19.4362H28.0844L27.725 20.2939H28.595L26.9482 24.2228Z",
    fill: "#3A3A3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3369 24.2228H31.5369L33.1836 20.2939H34.4036L34.7631 19.4362H33.5431L33.7093 19.0396C33.9142 18.5508 34.1615 18.3664 34.6315 18.3664H35.2615L35.6287 17.4902H34.6387C33.6487 17.4902 32.95 17.9883 32.5171 19.0212L32.3431 19.4362H31.4731L31.1136 20.2939H31.9836L30.3369 24.2228Z",
    fill: "#3A3A3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1274 44.1201C22.9574 44.1201 23.8274 43.2301 23.8274 41.3801V39.8201C23.8274 37.9701 22.9574 37.0801 21.1274 37.0801C19.2974 37.0801 18.4274 37.9701 18.4274 39.8201V41.3801C18.4274 43.2301 19.2974 44.1201 21.1274 44.1201ZM21.1274 43.0501C20.0874 43.0501 19.6474 42.5401 19.6474 41.3701V39.8301C19.6474 38.6601 20.0874 38.1501 21.1274 38.1501C22.1674 38.1501 22.6074 38.6601 22.6074 39.8301V41.3701C22.6074 42.5401 22.1674 43.0501 21.1274 43.0501Z",
    fill: "#3A3A3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1695 44.0001H26.3695V40.6301C26.6595 40.0401 27.0395 39.7501 27.5295 39.7501C28.0295 39.7501 28.2695 40.0401 28.2695 40.6801V44.0001H29.4695V40.5701C29.4695 39.3301 28.9195 38.6901 27.8395 38.6901C27.1595 38.6901 26.6495 38.9401 26.2295 39.5201L26.1895 38.8101H25.1695V44.0001Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSwitchOn);
export default __webpack_public_path__ + "static/media/light-switch-on.45f9fc42748bc52cb7e84f21d17825dc.svg";
export { ForwardRef as ReactComponent };